import _ from 'lodash';
import constants from '../constants';

export const translateTechnicalType = (technicalType, lang) => _.get(constants, `lang.${lang}.${technicalType}`.toLowerCase()) || technicalType;

export const getPriceNet = (priceBrut, deprecationPercent) => priceBrut + (priceBrut * deprecationPercent) / 100;
